<template>
  <div class="media-column" style="position: relative;">
    <div class="media-background" :style="midiaBgStyle" />
    <div style="z-index: 2;display: flex; align-content: center;">
      <span class="title-text">{{ headerText }}</span>
    </div>
    <div class="media-wrapper">
      <img v-if="midiaType === 'image'" :src="midiaUrl" class="image" style="position: relative;" />
      <video v-else :src="midiaUrl" class="video" autoplay style="position: relative;" />
    </div>
  </div>
</template>

<script>
const midiaBg = require("../../../assets/tarjas/panela-sportv/midia-vertical-container.png");

export default {
  props: {
    headerText: String,
    midiaType: String,
    midiaUrl: String,
    midiaSize: Object,
  },
  computed: {
    midiaBgStyle() {
      const backgroundStyle = `background-image: url(${midiaBg}); background-repeat: round; background-size: cover;`;
      return `${backgroundStyle};`;
    },
  },
};
</script>

<style scoped lang="scss">
.media-column {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 2;
}

.media-wrapper{
  display: flex;
  align-items: center;
  width: 315px;
  height: 572px;
}

.image,
.video {
  width: 100%;
  z-index: 1;
  border: 6px solid #bff65c;
  border-radius: 6px;
}

.title-text {
  color: white;
  z-index: 2;
  font-family: "Galeana-Condensed-Black", sans-serif;
  font-size: 3rem; 
  line-height: 2.6rem;
  text-align: center;
}

.media-background{
  position: absolute; 
  z-index: 0;
  width: 400px;
  height: 730px;
}
</style>
